
import React from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "jotai";
import { queryConfig } from "@/lib/query-config";
import Login from "./pages/auth/Login";
import AdminLayout from "./layouts/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import ClientList from "./pages/admin/clients/ClientList";
import ClientDetails from "./pages/admin/clients/ClientDetails";
import TemplateListV2 from "./pages/admin/templates_v2/TemplateList";
import TemplateDetailV2 from "./pages/admin/templates_v2/TemplateDetail";
import LaunchList from "./pages/admin/launches/LaunchList";
import LaunchDetail from "./pages/admin/launches/LaunchDetail";
import SubmissionListV2 from "./pages/admin/submissions/SubmissionListV2";
import SubmissionDetailV2 from "./pages/admin/submissions/SubmissionDetailV2";
import NotFound from "./pages/NotFound";
import UserList from "./pages/admin/users/UserList";
import CodeRedirect from "./pages/CodeRedirect";
import Index from "./pages/Index";
import JotFormDashboard from "./pages/admin/ServicioJuridicoDashboard";
import JotFormFormsList from "./pages/admin/jotform-forms/JotFormFormsList";
import JotFormFormConfig from "./pages/admin/jotform-forms/JotFormFormConfig";
import ProjectsPage from "./pages/admin/projects/ProjectsPage";
import ReferralsFunnel from "./pages/admin/referrals/ReferralsFunnel";
import BulkSendPage from "./pages/admin/bulk-send/BulkSendPage";

// QueryClient optimizado con configuración personalizada
const queryClient = new QueryClient({
  defaultOptions: queryConfig.defaultOptions,
});

const App = () => (
  <Provider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/auth/login" element={<Login />} />
              <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="clients" element={<ClientList />} />
              <Route path="clients/:id" element={<ClientDetails />} />
              <Route path="templates" element={<TemplateListV2 />} />
              <Route path="templates/:id" element={<TemplateDetailV2 />} />
              <Route path="launches" element={<LaunchList />} />
              <Route path="launches/:id" element={<LaunchDetail />} />
              <Route path="submissions" element={<SubmissionListV2 />} />
              <Route path="submissions/:id" element={<SubmissionDetailV2 />} />
              <Route path="users" element={<UserList />} />
              <Route path="informations" element={<JotFormDashboard />} />
              <Route path="forms" element={<JotFormFormsList />} />
              <Route path="forms/:id" element={<JotFormFormConfig />} />
              <Route path="projects" element={<ProjectsPage />} />
              <Route path="referrals-funnel" element={<ReferralsFunnel />} />
              <Route path="bulk-send" element={<BulkSendPage />} />
            </Route>
            <Route path="/:code" element={<CodeRedirect />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </Provider>
);

export default App;
